import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {Filter} from '../../services/model/filter.model';
import {environment} from '../../../environments/environment';
import {isNullOrUndefined} from "util";
import {GlobalService} from '../../services/global.service';

@Component({
    selector: 'app-filter-dialog',
    templateUrl: 'filter.component.html',
})
export class FilterComponent implements OnInit{
    data: any;
    env = environment;
    filter_type: string;
    statuses: any[];

    constructor(
        public dialogRef: MatDialogRef<FilterComponent>,
        public globalServ: GlobalService,
        @Inject(MAT_DIALOG_DATA) public filter: Filter
    ) {
        this.data = {};
        this.data = this.filter;
        this.statuses = [];
    }

    ngOnInit(){

        console.log(this.data, 'injected');

        for(let key in this.env.status){
            this.statuses.push(this.env.status[key])
        }

        console.log(this.statuses);

    }

    saveFilter(){
        this.data.platform = isNullOrUndefined(this.data.platform) ? '' : +this.data.platform;
        if(isNullOrUndefined(this.data.status)){
            this.data.status = ''
        }else{
            this.data.status = this.data.status == 4 ? 'default' : +this.data.status;
        }

        return this.dialogRef.close(this.data);
    }

    resetFilter(){
        this.data = {}
    }

    checkFilter(name: string){
        return this.globalServ.isFilterActive(this.filter_type, name) > -1;
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/dialogs/filter/filter.component.ts